import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../../constants';
import { AetStateService } from '../../services/aet-state.service';
import { environment } from "../../../environments/environment";
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false // NOSONAR
})
export class HeaderComponent implements OnInit,OnDestroy  {

	navlinks;
	rolesArray = [];
	userName: string = "";
	userInfo;
	newvar;
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;
	constructor(private  readonly constants: Constants,  private readonly aetStateService : AetStateService) { }

	ngOnInit(): void {
		this.navlinks = this.constants.navLinkItems;

		this.subscription = this.aetStateService.getDetails().subscribe(details => {
			this.fgaDetails = details;
			console.info('[Header] FGA details received:', details);
			if (this.fgaDetails) {
				this.userName = this.fgaDetails?.user?.firstName + ' ' + this.fgaDetails?.user?.lastName;
				let roles = []
				this.rolesArray = [];
				roles = this.fgaDetails?.roles
				if(roles?.length)
				{
					roles.forEach(e => {
						this.rolesArray.push(e.displayName)
					})
				}
			}
		});
	}

	logout() {
		localStorage.clear();
		sessionStorage.clear();
		window.location.replace(environment.LIOS_HOME_URL);
	}

	getrole(_newvar){
		console.info('something')
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	  }
}
